import React from "react";
import { Link } from "react-router-dom";
import { NewsletterForm } from "./NewsletterForm";
import { SystemStatusPill } from "./SystemStatusPill";

export const Footer = () => (
    <footer
        data-testid="footer"
        className="border-t-2 border-black bg-[#FDFBF7] mt-24"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
                <div className="font-display text-4xl font-black tracking-tighter">
                    FITS<span className="bg-black text-[#CCFF00] px-1 ml-1">ME</span>
                </div>
                <p className="mt-4 text-sm text-black/70 max-w-sm">
                    One search across every store, sized to fit you. Zara, H&amp;M, ASOS,
                    Nike, Adidas and more — only items in your size, with AI try-on
                    before you buy.
                </p>
                <div className="mt-5">
                    <h4 className="font-bold uppercase text-xs tracking-widest mb-2">Get the Friday Drop</h4>
                    <NewsletterForm variant="footer" source="footer" className="max-w-md" />
                </div>
            </div>
            <div>
                <h4 className="font-bold uppercase text-xs tracking-widest mb-3">
                    Company
                </h4>
                <ul className="space-y-2 text-sm">
                    <li><Link to="/about" data-testid="footer-about" className="hover:underline">About</Link></li>
                    <li><Link to="/contact" data-testid="footer-contact" className="hover:underline">Contact</Link></li>
                    <li><Link to="/returns-policy" data-testid="footer-returns-policy" className="hover:underline">Returns policy</Link></li>
                </ul>
            </div>
            <div>
                <h4 className="font-bold uppercase text-xs tracking-widest mb-3">
                    Support
                </h4>
                <ul className="space-y-2 text-sm">
                    <li>Sizing</li>
                    <li>Shipping</li>
                    <li><Link to="/returns" className="hover:underline">Returns</Link></li>
                    <li><Link to="/account" className="hover:underline">My account</Link></li>
                    <li><Link to="/privacy" className="hover:underline">Privacy</Link></li>
                    <li><Link to="/terms" className="hover:underline">Terms</Link></li>
                </ul>
            </div>
        </div>
        <div className="border-t-2 border-black py-4 px-4 flex flex-wrap items-center justify-center gap-3 font-mono text-xs uppercase tracking-widest">
            <span>© 2026 Fits Me — All rights reserved</span>
            <span className="text-black/30">·</span>
            <Link to="/contact" className="hover:underline">concierge@fitsme.shop</Link>
            <span className="text-black/30">·</span>
            <SystemStatusPill />
        </div>
    </footer>
);
